import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { BaseServiceService } from 'src/app/shared/services/base-service.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-modal-captura-direccion',
  templateUrl: './modal-captura-direccion.component.html',
  styleUrls: ['./modal-captura-direccion.component.scss']
})
export class ModalCapturaDireccionComponent implements OnInit, OnDestroy {

  @Input()
  direccion: string;

  @Input()
  direccion_estandar: DireccionEstandar | undefined;

  avenidas: ConvencionDireccion[] = [];
  adicionales: ConvencionDireccion[] = [];
  orientaciones: ConvencionDireccion[] = [];
  letras: ConvencionDireccion[] = [];

  formDireccion: FormGroup;
  formDireccionBuilder: FormGroup;

  private _subscriptionFormDireccionBuilder: Subscription | undefined;
  private _subscriptionUsaFormatoCompleto: Subscription | undefined;

  constructor(
    private _activeModal: NgbActiveModal,
    private _baseService: BaseServiceService,
    private _fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.formDireccion = this._fb.group({
      direccionCtrl: [this.direccion, [Validators.required]]
    });

    this.formDireccionBuilder = this._fb.group({
      usaFormatoCompletoCtrl: [true, []],
      pCalleCtrl: [undefined, [Validators.required]],
      pNumeroCtrl: [undefined, [Validators.required]],
      pLetraCtrl: [undefined, []],
      pOrientacionCtrl: [undefined, []],
      s1NumeroCtrl: [undefined, [Validators.required]],
      s1LetraCtrl: [undefined, []],
      s1OrientacionCtrl: [undefined, []],
      s2NumeroCtrl: [undefined, []],
      s2LetraCtrl: [undefined, []],
      s2OrientacionCtrl: [undefined, []],
      a1AbreviaturaCtrl: [undefined, []],
      a1ValorCtrl: [undefined, []],
      a2AbreviaturaCtrl: [undefined, []],
      a2ValorCtrl: [undefined, []],
      a3AbreviaturaCtrl: [undefined, []],
      a3ValorCtrl: [undefined, []],
      a4AbreviaturaCtrl: [undefined, []],
      a4ValorCtrl: [undefined, []],
      direccionNoEstructuradaCtrl: [undefined, []]
    });

    this.observarUsaFormatoCompleto();
    this.observarFormDireccionBuilder();

    this._baseService.getConvencionesDireccion().pipe(
      map(respuesta => respuesta.data as ConvencionDireccion[])
    ).subscribe((convecionesDireccion: ConvencionDireccion[]) => {
      this.avenidas = convecionesDireccion.filter(x => x.tipo == 1);
      this.adicionales = convecionesDireccion.filter(x => x.tipo == 2);
      this.orientaciones = convecionesDireccion.filter(x => x.tipo == 3);
      this.letras = convecionesDireccion.filter(x => x.tipo == 4);

      if (this.direccion_estandar)
        this.formDireccionBuilder.patchValue({
          'usaFormatoCompletoCtrl': this.direccion_estandar.usa_formato_completo,
          'pCalleCtrl': this.avenidas.find(x => x.abreviatura == this.direccion_estandar.p_abreviatura_calle),
          'pNumeroCtrl': this.direccion_estandar.p_numero,
          'pLetraCtrl': this.letras.find(x => x.abreviatura == this.direccion_estandar.p_abreviatura_letra),
          'pOrientacionCtrl': this.orientaciones.find(x => x.abreviatura == this.direccion_estandar.p_abreviatura_orientacion),
          's1NumeroCtrl': this.direccion_estandar.s1_numero,
          's1LetraCtrl': this.letras.find(x => x.abreviatura == this.direccion_estandar.s1_abreviatura_letra),
          's1OrientacionCtrl': this.orientaciones.find(x => x.abreviatura == this.direccion_estandar.s1_abreviatura_orientacion),
          's2NumeroCtrl': this.direccion_estandar.s2_numero,
          's2LetraCtrl': this.letras.find(x => x.abreviatura == this.direccion_estandar.s2_abreviatura_letra),
          's2OrientacionCtrl': this.orientaciones.find(x => x.abreviatura == this.direccion_estandar.s2_abreviatura_orientacion),
          'a1AbreviaturaCtrl': this.adicionales.find(x => x.abreviatura == this.direccion_estandar.a1_abreviatura),
          'a1ValorCtrl': this.direccion_estandar.a1_valor,
          'a2AbreviaturaCtrl': this.adicionales.find(x => x.abreviatura == this.direccion_estandar.a2_abreviatura),
          'a2ValorCtrl': this.direccion_estandar.a2_valor,
          'a3AbreviaturaCtrl': this.adicionales.find(x => x.abreviatura == this.direccion_estandar.a3_abreviatura),
          'a3ValorCtrl': this.direccion_estandar.a3_valor,
          'a4AbreviaturaCtrl': this.adicionales.find(x => x.abreviatura == this.direccion_estandar.a4_abreviatura),
          'a4ValorCtrl': this.direccion_estandar.a4_valor,
          'direccionNoEstructuradaCtrl': this.direccion_estandar.direccion_no_estructurada,
        });
    });
  }

  ngOnDestroy(): void {
    this._subscriptionFormDireccionBuilder?.unsubscribe();
    this._subscriptionUsaFormatoCompleto?.unsubscribe();
  }

  onCancelar(): void {
    this._activeModal.close();
  }

  onConfirmar(): void {
    const { direccionCtrl } = this.formDireccion.value;
    const resultado: ResultadoModalCapturaDireccion = {
      direccion: direccionCtrl,
      direccion_estandar: this.direccion_estandar
    };
    this._activeModal.close(resultado);
  }

  private observarUsaFormatoCompleto() {
    this._subscriptionUsaFormatoCompleto = this.usaFormatoCompletoCtrl.valueChanges.subscribe(usaFormatoCompleto => {
      if (usaFormatoCompleto) {
        this.pCalleCtrl.enable();
        this.pNumeroCtrl.enable();
        this.pLetraCtrl.enable();
        this.pOrientacionCtrl.enable();
        this.s1NumeroCtrl.enable();
        this.s1LetraCtrl.enable();
        this.s1OrientacionCtrl.enable();
        this.s2NumeroCtrl.enable();
        this.s2LetraCtrl.enable();
        this.s2OrientacionCtrl.enable();

        this.pCalleCtrl.setValidators([Validators.required]);
        this.pNumeroCtrl.setValidators([Validators.required, Validators.min(1)]);
        this.s1NumeroCtrl.setValidators([Validators.required, Validators.min(1)]);
        this.s2NumeroCtrl.setValidators([Validators.required, Validators.min(1)]);
      } else {
        this.pCalleCtrl.disable();
        this.pNumeroCtrl.disable();
        this.pLetraCtrl.disable();
        this.pOrientacionCtrl.disable();
        this.s1NumeroCtrl.disable();
        this.s1LetraCtrl.disable();
        this.s1OrientacionCtrl.disable();
        this.s2NumeroCtrl.disable();
        this.s2LetraCtrl.disable();
        this.s2OrientacionCtrl.disable();

        this.pCalleCtrl.clearValidators();
        this.pNumeroCtrl.clearValidators();
        this.s1NumeroCtrl.clearValidators();
        this.s2NumeroCtrl.clearValidators();
      }
    });
  }

  private observarFormDireccionBuilder() {
    this._subscriptionFormDireccionBuilder = this.formDireccionBuilder.valueChanges.subscribe(({
      usaFormatoCompletoCtrl, pCalleCtrl, pNumeroCtrl, pLetraCtrl, pOrientacionCtrl, s1NumeroCtrl, s1LetraCtrl, s1OrientacionCtrl, s2NumeroCtrl, s2LetraCtrl, s2OrientacionCtrl, a1AbreviaturaCtrl, a1ValorCtrl, a2AbreviaturaCtrl, a2ValorCtrl, a3AbreviaturaCtrl, a3ValorCtrl, a4AbreviaturaCtrl, a4ValorCtrl, direccionNoEstructuradaCtrl
    }) => {
      var tmpDireccion = '';

      if (this.formDireccionBuilder.invalid) {
        this.direccionCtrl.setValue(tmpDireccion);
        this.direccion_estandar = undefined;
        return;
      }

      let tmpDireccionEstandar: DireccionEstandar = {
        usa_formato_completo: usaFormatoCompletoCtrl,
        p_abreviatura_calle: pCalleCtrl?.abreviatura,
        p_numero: pNumeroCtrl,
        p_abreviatura_letra: pLetraCtrl?.abreviatura,
        p_abreviatura_orientacion: pOrientacionCtrl?.abreviatura,
        s1_numero: s1NumeroCtrl,
        s1_abreviatura_letra: s1LetraCtrl?.abreviatura,
        s1_abreviatura_orientacion: s1OrientacionCtrl?.abreviatura,
        s2_numero: s2NumeroCtrl,
        s2_abreviatura_letra: s2LetraCtrl?.abreviatura,
        s2_abreviatura_orientacion: s2OrientacionCtrl?.abreviatura,
        direccion_no_estructurada: direccionNoEstructuradaCtrl
      };

      if (pCalleCtrl)
        tmpDireccion = tmpDireccion.concat(pCalleCtrl.nombre_completo);


      if (pNumeroCtrl)
        tmpDireccion = tmpDireccion.concat(' ', pNumeroCtrl);

      if (pLetraCtrl)
        tmpDireccion = tmpDireccion.concat(' ', pLetraCtrl.nombre_completo);

      if (pOrientacionCtrl)
        tmpDireccion = tmpDireccion.concat(' ', pOrientacionCtrl.nombre_completo);


      if (s1NumeroCtrl)
        tmpDireccion = tmpDireccion.concat(' # ', s1NumeroCtrl);

      if (s1LetraCtrl)
        tmpDireccion = tmpDireccion.concat(s1LetraCtrl.nombre_completo);

      if (s1OrientacionCtrl)
        tmpDireccion = tmpDireccion.concat(' ', s1OrientacionCtrl.nombre_completo);

      if (s2NumeroCtrl)
        tmpDireccion = tmpDireccion.concat(' - ', s2NumeroCtrl);

      if (s2LetraCtrl)
        tmpDireccion = tmpDireccion.concat(' ', s2LetraCtrl.nombre_completo);

      if (s2OrientacionCtrl)
        tmpDireccion = tmpDireccion.concat(' ', s2OrientacionCtrl.nombre_completo);


      if (a1AbreviaturaCtrl && a1ValorCtrl) {
        tmpDireccion = tmpDireccion.concat(' ', a1AbreviaturaCtrl.nombre_completo, ' ', a1ValorCtrl);
        tmpDireccionEstandar.a1_abreviatura = a1AbreviaturaCtrl.abreviatura;
        tmpDireccionEstandar.a1_valor = a1ValorCtrl;
      }

      if (a2AbreviaturaCtrl && a2ValorCtrl) {
        tmpDireccion = tmpDireccion.concat(' ', a2AbreviaturaCtrl.nombre_completo, ' ', a2ValorCtrl);
        tmpDireccionEstandar.a2_abreviatura = a2AbreviaturaCtrl.abreviatura;
        tmpDireccionEstandar.a2_valor = a2ValorCtrl;
      }

      if (a3AbreviaturaCtrl && a3ValorCtrl) {
        tmpDireccion = tmpDireccion.concat(' ', a3AbreviaturaCtrl.nombre_completo, ' ', a3ValorCtrl);
        tmpDireccionEstandar.a3_abreviatura = a3AbreviaturaCtrl.abreviatura;
        tmpDireccionEstandar.a3_valor = a3ValorCtrl;
      }

      if (a4AbreviaturaCtrl && a4ValorCtrl) {
        tmpDireccion = tmpDireccion.concat(' ', a4AbreviaturaCtrl.nombre_completo, ' ', a4ValorCtrl);
        tmpDireccionEstandar.a3_abreviatura = a3AbreviaturaCtrl.abreviatura;
        tmpDireccionEstandar.a3_valor = a3ValorCtrl;
      }

      if (direccionNoEstructuradaCtrl)
        tmpDireccion = tmpDireccion.concat(' ', direccionNoEstructuradaCtrl);

      tmpDireccion = tmpDireccion.trim();

      this.direccionCtrl.setValue(tmpDireccion);
      this.direccion_estandar = tmpDireccionEstandar;
    });
  }

  get direccionCtrl(): AbstractControl {
    return this.formDireccion.get('direccionCtrl')!!;
  }

  get usaFormatoCompletoCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('usaFormatoCompletoCtrl')!!;
  }
  get pCalleCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('pCalleCtrl')!!;
  }
  get pNumeroCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('pNumeroCtrl')!!;
  }
  get pLetraCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('pLetraCtrl')!!;
  }
  get pOrientacionCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('pOrientacionCtrl')!!;
  }
  get s1NumeroCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('s1NumeroCtrl')!!;
  }
  get s1LetraCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('s1LetraCtrl')!!;
  }
  get s1OrientacionCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('s1OrientacionCtrl')!!;
  }
  get s2NumeroCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('s2NumeroCtrl')!!;
  }
  get s2LetraCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('s2LetraCtrl')!!;
  }
  get s2OrientacionCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('s2OrientacionCtrl')!!;
  }
  get a1AbreviaturaCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('a1AbreviaturaCtrl')!!;
  }
  get a1ValorCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('a1ValorCtrl')!!;
  }
  get a2AbreviaturaCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('a2AbreviaturaCtrl')!!;
  }
  get a2ValorCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('a2ValorCtrl')!!;
  }
  get a3AbreviaturaCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('a3AbreviaturaCtrl')!!;
  }
  get a3ValorCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('a3ValorCtrl')!!;
  }
  get a4AbreviaturaCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('a4AbreviaturaCtrl')!!;
  }
  get a4ValorCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('a4ValorCtrl')!!;
  }
  get direccionNoEstructuradaCtrl(): AbstractControl {
    return this.formDireccionBuilder.get('direccionNoEstructuradaCtrl')!!;
  }
}

export interface ResultadoModalCapturaDireccion {
  direccion: string;
  direccion_estandar?: DireccionEstandar
}

export interface ConvencionDireccion {
  abreviatura: string;
  nombre_completo: string;
  tipo: number;
}

export interface DireccionEstandar {
  p_numero?: number;
  p_abreviatura_calle?: string;
  p_abreviatura_letra?: string;
  p_abreviatura_orientacion?: string;
  s1_numero?: number;
  s1_abreviatura_letra?: string;
  s1_abreviatura_orientacion?: string;
  s2_numero?: number;
  s2_abreviatura_letra?: string;
  s2_abreviatura_orientacion?: string;
  a1_abreviatura?: string;
  a1_valor?: string;
  a2_abreviatura?: string;
  a2_valor?: string;
  a3_abreviatura?: string;
  a3_valor?: string;
  a4_abreviatura?: string;
  a4_valor?: string;
  direccion_no_estructurada?: string;
  usa_formato_completo: boolean;
}